import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    teacherBatchList: [],
    batchList: [],
    totalRecords: 0,
    batchDetails: {},
    message: null,
    batchChangeListLoading: false,
    batchChangeListSuccess: {},
    batchChangeListFailure: ""
}

export const batchTypeSlice = createSlice({
    name: 'batch',
    initialState,
    reducers: {
        getBatchList: (state, action) => {
            state.batchList = action.payload.data?.data;
            state.totalRecords = action.payload.data?.totalRecord;
            state.message = action.payload.message;
        },
        getTeacherBatchList: (state, action) => {
            state.teacherBatchList = action.payload;
        },
        getBatchDetails: (state, action) => {
            state.batchDetails = action.payload
        },
        setBatchChangeListLoading: (state, action) => {
            state.batchChangeListLoading = true;
            state.batchChangeListSuccess = {}
            state.batchChangeListFailure = ""
        },
        setBatchChangeSuccess: (state, action) => {
            state.batchChangeListLoading = false;
            state.batchChangeListSuccess = action.payload
            state.batchChangeListFailure = ""
        },
        setBatchChangeFailure: (state, action) => {
            state.batchChangeListLoading = false;
            state.batchChangeListSuccess = ""
            state.batchChangeListFailure = action.payload.message
        }
    },
})

// Action creators are generated for each case reducer function
export const { getBatchList, getTeacherBatchList,getBatchDetails,
     setBatchChangeListLoading, setBatchChangeSuccess, setBatchChangeFailure } = batchTypeSlice.actions

export default batchTypeSlice.reducer;